module.exports = __webpack_public_path__ + "static/media/Pedders_logo.8e21806f.webp";